import styled from 'styled-components'

export const ScratchContainer = styled.div<{
  $revealed: boolean
}>`
  position: relative;
  border-radius: 8px;
  border: ${(props) => (props.$revealed ? '1px dashed #f5a151' : '1px solid #ec7f1a')};
  overflow: hidden;
`

export const ScratchGift = styled.div<{
  $hasFinished: boolean
  $isAwarded: boolean
}>`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 128px;
  height: 128px;
  background-color: #feead4; /* Non equivalent color in DS */
  transition: all 0.5s;

  ${(props) => props.$hasFinished && !props.$isAwarded && `filter: grayscale(1);`}

  img {
    width: 64px;
    height: 63px;
    margin: 16px 0;
  }

  span {
    color: black; /* Non equivalent color in DS */
  }
`

export const ScratchCanvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;

  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  image-rendering: crisp-edges;
`
